function report_entries_Reducer(state = [], action) {
    switch (action.type) {
        case 'REPORT/ENTRIES/SET':                        
            return action.entries;
        case 'REPORT/ENTRIES/CLEAR':
            return null;
        default:
            return state;
    }
}

export default report_entries_Reducer;
